import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=d70bd8a6"
import script from "./MyDashboard.vue?vue&type=script&lang=ts"
export * from "./MyDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports